import { render, staticRenderFns } from "./DeleteCompletedModal.vue?vue&type=template&id=23f7abb5&scoped=true&"
import script from "./DeleteCompletedModal.vue?vue&type=script&lang=js&"
export * from "./DeleteCompletedModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteCompletedModal.vue?vue&type=style&index=0&id=23f7abb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f7abb5",
  null
  
)

export default component.exports